import { Component, createRef } from 'react';
import { arrayOf, bool, node, oneOfType, string } from 'prop-types';
import classnames from 'classnames';

import { throttle } from '~/utils';

import styles from './Sticky.scss';

export class Sticky extends Component {
  state = {
    isSticky: false,
  };

  stickyRef = createRef();

  containerRef = createRef();

  handleScroll = throttle(() => {
    const { current: containerEl } = this.containerRef;
    const { current: stickyEl } = this.stickyRef;

    const { top } = containerEl.getBoundingClientRect();
    const { height } = stickyEl.getBoundingClientRect();

    const isSticky = top <= 0;

    this.setState({ isSticky });

    containerEl.style.height = isSticky ? `${height}px` : '';
  }, 50);

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { enabled, children, className } = this.props;
    const { isSticky } = this.state;

    return (
      <div ref={this.containerRef}>
        <div
          data-test-id="sticky"
          ref={this.stickyRef}
          className={classnames({
            [styles.Sticky]: enabled && isSticky,
            [className]: enabled && isSticky,
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}

Sticky.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  enabled: bool,
  className: string,
};

Sticky.defaultProps = {
  enabled: true,
  className: undefined,
};
